import type { StateWithFileMetadata } from './reducer'

export const getFileMetadata = (state: StateWithFileMetadata) => state.fileMetadata
